import { createBrowserRouter } from "react-router-dom";
import { ProtectedRoute } from "@components/ProtectedRoute";
import { AppLayout } from "@components/Layout";
import Login from "@pages/Login";
import PreviewPage from "@pages/PreviewPage";
import Dashboard from "@pages/Dashboard";
import Categories from "@pages/Categories";
import Restaurants from "@pages/Restaurants";
import AddRestaurant from "@pages/AddRestaurant";
import CreateEvent from "@pages/CreateEvent";
import EventDetails from "@pages/EventDetails";
import ReviewSubmission from "@pages/ReviewSubmission";
import History from "@pages/History";
import Analytics from "@pages/Analytics";
import Account from "@pages/Account";

export const router = createBrowserRouter([
  {
    element: <AppLayout />,
    children: [
      { path: "/", element: <Login /> },
      { path: "/preview", element: <PreviewPage /> },
      {
        element: <ProtectedRoute />,
        children: [
          { path: "/dashboard", element: <Dashboard /> },
          { path: "/categories", element: <Categories /> },
          { path: "/restaurants", element: <Restaurants /> },
          { path: "/restaurants/new", element: <AddRestaurant /> },
          { path: "/restaurants/:id/edit", element: <AddRestaurant /> },
          { path: "/events/new", element: <CreateEvent /> },
          { path: "/events/:id", element: <EventDetails /> },
          { path: "/events/:id/review", element: <ReviewSubmission /> },
          { path: "/history", element: <History /> },
          { path: "/analytics", element: <Analytics /> },
          { path: "/account", element: <Account /> },
        ],
      },
    ],
  },
]);
